import { LinkField, ImageField, Image, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import Link from 'components/helpers/Link/Link';
import React, { useContext } from 'react';
import { contextType, HeaderContext } from './Header';

type LogoLinkProps = {
  logo: ImageField;
  link: LinkField;
};

const LogoLink = (props: LogoLinkProps): React.JSX.Element | null => {
  const { sitecoreContext } = useSitecoreContext();
  const { pageEditing } = sitecoreContext;

  const { resetMobileMenu, currentLang, datasourceLanguage } = useContext(HeaderContext) as contextType;

  /**
   * Checking if there was a logo image provided.
   * If none, return null.
   */
  if (!pageEditing && props.logo?.value?.src === undefined) {
    return null;
  }

  /**
   * Checking if the logo should act as a link.
   * If a link is provide logo will be wrapped in an anchor.
   */
  if (props.link?.value?.href !== '' || pageEditing) {
    return (
      <Link
        field={props.link}
        showLinkTextWithChildrenPresent={false}
        lang={datasourceLanguage ?? currentLang}
        onClick={() => {
          resetMobileMenu();
        }}
      >
        <Image field={props.logo} />
      </Link>
    );
  }

  return <Image field={props.logo} />;
};

export default LogoLink;
